import { App } from 'vue';

// Components
import DfButton from '/@elements/DfButton/DfButton.vue';
import DfCounter from '/@elements/DfCounter/DfCounter.vue';
import DfDatepicker from '/@elements/DfDatepicker/DfDatepicker.vue';
import DfDropdown from '/@elements/DfDropdown/DfDropdown.vue';
import DfDropdown2Item from '/@elements/DfDropdown2Item/DfDropdown2Item.vue';
import DfDropdownItem from '/@elements/DfDropdownItem/DfDropdownItem.vue';
import DfDropdownItemBlock from '/@elements/DfDropdownItemBlock/DfDropdownItemBlock.vue';
import DfDropdownItemConfirm from '/@elements/DfDropdownItemConfirm/DfDropdownItemConfirm.vue';
import DfDropdownItemInput from '/@elements/DfDropdownItemInput/DfDropdownItemInput.vue';
import DfFab from '/@elements/DfFab/DfFab.vue';
import DfHeader from '/@elements/DfHeader/DfHeader.vue';
import DfIcon from '/@elements/DfIcon/DfIcon.vue';
import DfInput from '/@elements/DfInput/DfInput.vue';
import DfInputSearch from '/@elements/DfInputSearch/DfInputSearch.vue';
import DfModal from '/@elements/DfModal/DfModal.vue';
import DfSelect from '/@elements/DfSelect/DfSelect.vue';
import DfSelect3 from '/@elements/DfSelect3/DfSelect3.vue';
import DfTime from '/@elements/DfTime/DfTime.vue';

import DfTooltip from './elements/DfTooltip/DfTooltip.vue';
import DfAlert from '/@elements/DfAlert/DfAlert.vue';
import DfButtonGroup from '/@elements/DfButtonGroup/DfButtonGroup.vue';
import DfCheckbox from '/@elements/DfCheckbox/DfCheckbox.vue';
import DfConfirmModal from '/@elements/DfConfirmModal/DfConfirmModal.vue';
import DfDeleteButton from '/@elements/DfDeleteButton/DfDeleteButton.vue';
import DfForm from '/@elements/DfForm/DfForm.vue';
import DfLoading from '/@elements/DfLoading/DfLoading.vue';
import DfProgress from '/@elements/DfProgress/DfProgress.vue';

export function installComponents(app: App<Element>) {
  app
    .component('DfIcon', DfIcon)
    .component('DfDropdown', DfDropdown)
    .component('DfDropdownItem', DfDropdownItem)
    .component('DfDropdownItemBlock', DfDropdownItemBlock)
    .component('DfDropdownItemInput', DfDropdownItemInput)
    .component('DfDropdownItemConfirm', DfDropdownItemConfirm)
    .component('DfDropdown2Item', DfDropdown2Item)
    .component('DfButton', DfButton)
    .component('DfFab', DfFab)
    .component('DfDeleteButton', DfDeleteButton)
    .component('DfModal', DfModal)
    .component('DfLoading', DfLoading)
    .component('DfAlert', DfAlert)
    .component('DfForm', DfForm)
    .component('DfHeader', DfHeader)
    .component('DfConfirmModal', DfConfirmModal)
    .component('DfTooltip', DfTooltip)
    // inputs
    .component('DfSelect', DfSelect)
    .component('DfSelect3', DfSelect3)
    .component('DfInput', DfInput)
    .component('DfDatepicker', DfDatepicker)
    .component('DfCounter', DfCounter)
    .component('DfTime', DfTime)
    .component('DfCheckbox', DfCheckbox)
    .component('DfButtonGroup', DfButtonGroup)
    .component('DfInputSearch', DfInputSearch)
    .component('DfProgress', DfProgress);
}
